// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__meB2o","contentWrapper":"styles_contentWrapper__FgCJA","widthSmall":"styles_widthSmall__Vu+wh","widthFull":"styles_widthFull__9+U2Y"};